export const t = { "en": { "ui-addon-video-player": { "havingTroubleWithVideoLink": "Having trouble watching this video?", "playButton": "Play" } } };
export const d = [];